// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.directAnswerMatching {
  width: 100%;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 35px;
}

.btnResponseMinusParti {
  border-radius: 14%;
  color: #f2f2f2;
  border: none;
  font-size: 12px;
  padding: 3px 7px;
  background: #68dff0;
  margin-top: 8px;
  cursor: pointer;
  max-height: 18px;
}

.searchQuestionLabelMatching {
  font-size: 18px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 10px;
  width: 15px;
  margin-left: 18%;
}

.matchingInput {
  box-sizing: border-box;
  width: 70%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 2%;
  margin-right: 1%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}

.matchingSelect {
  box-sizing: border-box;
  width: 50%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 2%;
  margin-right: 4%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/Matching/matching.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB","sourcesContent":[".directAnswerMatching {\n  width: 100%;\n  display: flex;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  min-height: 35px;\n}\n\n.btnResponseMinusParti {\n  border-radius: 14%;\n  color: #f2f2f2;\n  border: none;\n  font-size: 12px;\n  padding: 3px 7px;\n  background: #68dff0;\n  margin-top: 8px;\n  cursor: pointer;\n  max-height: 18px;\n}\n\n.searchQuestionLabelMatching {\n  font-size: 18px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 10px;\n  width: 15px;\n  margin-left: 18%;\n}\n\n.matchingInput {\n  box-sizing: border-box;\n  width: 70%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 2%;\n  margin-right: 1%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n\n.matchingSelect {\n  box-sizing: border-box;\n  width: 50%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 2%;\n  margin-right: 4%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
